<div id="price_infos" class="bg-price_box px-4 pt-4 pb-3 mb-0 br-16 my-5">
  <h2 class="title_2 pb-4 mb-0">
    {{ 'PROCESSES.ACCOMMODATION.PRICE_DETAILS.TITLE' | translate }}
  </h2>

  <div class="payment_owner">
    <div class="pb-2">
      <span class="subtitle-text subtitle_1">
        {{ 'PROCESSES.ACCOMMODATION.PRICE_DETAILS.SUBTITLE_1' | translate }}
      </span>
    </div>

    <div *ngFor="let spec of priceLfSpecificity; let index = index">
      <div class="d-flex txt-blue-sky justify-content-between subtitle_1 pb-1">
        <span>{{ spec.title | translate }}</span>

        <div>
          <span class="text-decoration-line-through me-2 mediumGray subtitle_1" *ngIf="room.property_price && room.property_price.old_reservation_fees && (room.property_price['old_reservation_fees'] > room.property_price['reservation_fees'])">
            {{ room.property_price['old_reservation_fees'] | number: '1.0-0'}}€
          </span>
          <span class="title_2 price-style" *ngIf="spec.price"
            [contentEditable]="isAdmin && spec.isEditable"
            (input)="change('partner_fees', $event)"
            (focusout)="updateRoom()">
          {{ spec.price | number: '1.0-0' }}€
        </span>
        </div>

      </div>
      <div class="d-flex gap-8 align-items-center text_1" *ngFor="let specContent of spec.subItems" [ngClass]="{'w-75': !isMobile}">
        {{ 'PROCESSES.ACCOMMODATION.P_SPEC.LIST' + '.' + specContent | translate }}
      </div>
    </div>
  </div>

  <hr class="payment">

  <div class="payment_owner">
    <div class="pb-2">
      <span class="subtitle-text subtitle_1">
        {{ 'PROCESSES.ACCOMMODATION.PRICE_DETAILS.SUBTITLE_2' | translate }}
      </span>
    </div>
    <div class="pb-3" *ngFor="let spec of pricePartnerSpecificity; let index = index">
      <div class="d-flex txt-dark-blue justify-content-between subtitle_1 pb-1">
        <span>{{ spec.title | translate }}</span>

        <div>
          <span class="text-decoration-line-through me-2 mediumGray subtitle_1"
            *ngIf="room.property_price && room.property_price.oldPartnerFees && spec.subItems[0] == 'PARTNER_FEES'">
            {{ room.property_price.oldPartnerFees | number: '1.0-0'}}€
          </span>
          <span class="title_2 price-style"
            [contentEditable]="isAdmin && spec.isEditable"
            (input)="change('partner_fees', $event)"
            (focusout)="updateRoom()">
            {{ spec.price | number: '1.0-0' }}€
          </span>
        </div>

      </div>
      <div class="d-flex gap-8 align-items-center text_1" *ngFor="let specContent of spec.subItems" [ngClass]="{'w-75': !isMobile}">

        <div *ngIf="specContent !== 'RESERVATION_MIN'">
          {{ 'PROCESSES.ACCOMMODATION.P_SPEC.LIST' + '.' + specContent | translate }}
        </div>

        <!--  CHARGES  -->
        <div *ngIf="specContent == 'RESERVATION_MIN'">
          <div class="d-flex flex-row subtitle_2 pb-2 mb-0 align-items-center">
            {{ 'PROCESSES.ACCOMMODATION.LIST.RENTAL_CHARGES' | translate }}
            ({{ 'PROCESSES.ACCOMMODATION.CHARGES.PROVISIONS_ON_COSTS' | translate }})
            <lf-icon name="question" class="icon-charges ms-2 margin-charges" width="14px" height="14px" fillColor="#FFFFFF" (click)="$event.stopPropagation();gotoHelpCenter()"></lf-icon>
          </div>

          <div class="d-flex flex-wrap flex-row">
            <div class="d-flex flex-row align-items-center gap-8 w-50 pb-2" *ngIf="room.property_price.wifi">
              <lf-icon class="icon-charges" name="wifi" width="20px" height="20px" fillColor="#002FA7"></lf-icon>
              <div class="font-14">
                <div class="mediumGray">{{ "PROCESSES.ACCOMMODATION.AMENITIES.WIFI" | translate }}</div>
              </div>
            </div>

            <div class="d-flex flex-row align-items-center gap-8 w-50 pb-2" *ngIf="room.property_price.electricity">
              <lf-icon class="icon-charges" name="elec" width="20px" height="20px" fillColor="#002FA7"></lf-icon>
              <div class="font-14">
                <div class="mediumGray">{{ "PROCESSES.ACCOMMODATION.CHARGES.ELECTRICITY" | translate }}</div>
              </div>
            </div>

            <div *ngIf="room.property_price.insurance || (room.charges && room.charges.includes('assurance habitation'))"
                 class="d-flex flex-row align-items-center gap-8 w-50 pb-2">
              <lf-icon class="icon-charges" name="home" width="20px" height="20px" fillColor="#002FA7"></lf-icon>
              <div class="font-14">
                <div class="mediumGray">
                  {{ "PROCESSES.HOUSING_INSURANCE.TITLE" | translate }}
                </div>
              </div>
            </div>

            <div class="d-flex flex-row align-items-center gap-8 w-50 pb-2" *ngIf="room.property_price.water">
              <lf-icon class="icon-charges" name="water" width="20px" height="20px" fillColor="#002FA7"></lf-icon>
              <div class="font-14">
                <div class="mediumGray">{{ "PROCESSES.ACCOMMODATION.CHARGES.WATER" | translate }}</div>
              </div>
            </div>

            <div class="d-flex flex-row align-items-center gap-8 w-50 pb-2" *ngIf="room.property_price.cleaning">
              <lf-icon class="icon-charges" name="clean" width="20px" height="20px" fillColor="#002FA7"></lf-icon>
              <div class="font-14">
                <div class="mediumGray">{{ "PROCESSES.ACCOMMODATION.CHARGES.CLEANING" | translate }}</div>
              </div>
            </div>

            <div class="d-flex flex-row align-items-center gap-8 w-50" *ngIf="room.property_price.gaz">
              <lf-icon class="icon-charges" name="gaz" width="20px" height="20px" fillColor="#002FA7"></lf-icon>
              <div class="font-14">
                <div class="mediumGray">{{ "PROCESSES.ACCOMMODATION.CHARGES.GAZ" | translate }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="d-flex align-items-center justify-content-center pb-3">
    <div class="d-flex advantages-col" [ngClass]="{'w-75': !isMobile}">
      <div class="d-flex flex-row align-items-center w-100" [ngClass]="isMobile ? 'm-2' : 'm-3'">
        <lf-icon name="returnMoney" width="24px" height="24px" fillColor="#00C49A"></lf-icon>
        <div class="icon-margin">
          <p class="text_3">{{ 'ROOM.ADVANTAGES.REFUND' | translate }}</p>
        </div>
      </div>

      <div class="d-flex flex-row align-items-center w-100" [ngClass]="isMobile ? 'm-2' : 'm-3'">
        <lf-icon name="safeHome" width="24px" height="24px" fillColor="#00C49A"></lf-icon>
        <div class="icon-margin">
          <p class="text_3">{{ 'ROOM.ADVANTAGES.HELP' | translate }}</p>
        </div>
      </div>
    </div>
  </div>



</div>
